<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header = "Información del Pais">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model"
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Cod.País"
              label-for="afipCodigoPais"
              :label-cols="labelCols"
              description="Código País - AFIP (Fact. de Exportación)"
              horizontal>
              <b-form-input 
                id="afipCodigoPais"
                v-model.trim="$v.afipCodigoPais.$model"
                :state="afipCodigoPaisValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="afipCodigoPaisFeedback">
                {{ afipCodigoPaisInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CUIT País"
              label-for="afipCuitPais"
              :label-cols="labelCols"
              description="CUIT País - AFIP (Fact. de Exportación)"
              horizontal>
              <b-form-input 
                id="afipCuitPais"
                v-model.trim= "$v.afipCuitPais.$model"
                :state="afipCuitPaisValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="afipCuitPaisFeedback">
                {{ afipCuitPaisInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols">
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength, numeric, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'pais/getField',
  mutationType: 'pais/updateField',
});

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      afipCodigoPaisValido: null,
      afipCodigoPaisInvalidoMsj: '',
      afipCuitPaisValido: null,
      afipCuitPaisInvalidoMsj: '',

      labelCols: 1
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'afipCodigoPais',
      'afipCuitPais',
      'inactivo',
    ])
  },
  created() {
    let paisId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        paisId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('pais/inicializar', paisId)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del pais';
          } else if (this.$v.nombre.$error && !this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == "afipCodigoPais" || validarTodos) {
        if (this.$v.afipCodigoPais.$error) {
          this.afipCodigoPaisValido = false;
          if (!this.$v.afipCodigoPais.required) {
            this.afipCodigoPaisInvalidoMsj = 'Debe ingresar el código de pais.';
          } else if (!this.$v.afipCodigoPais.numeric || !this.$v.afipCodigoPais.minValue || !this.$v.afipCodigoPais.maxValue) {
            this.afipCodigoPaisInvalidoMsj = 'El código de pais ingresado no es válido.';
          }      
        } else {
          this.afipCodigoPaisValido = null;
          this.afipCodigoPaisInvalidoMsj = '';
        }
      }

      if (campo == "afipCuitPais" || validarTodos) {
        if (this.$v.afipCuitPais.$error) {
          this.afipCuitPaisValido = false;
          if (!this.$v.afipCuitPais.required) {
            this.afipCuitPaisInvalidoMsj = 'Debe ingresar el CUIT del pais.';
          } else if (!this.$v.afipCuitPais.numeric || !this.$v.afipCuitPais.minValue || !this.$v.afipCuitPais.maxValue) {
            this.afipCuitPaisInvalidoMsj = 'El CUIT del pais ingresado no es válido.';
          }      
        } else {
          this.afipCuitPaisValido = null;
          this.afipCuitPaisInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('pais/save')
          .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      }
    },
    goList() {
      this.$router.push({ name: "Paises" });
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    afipCodigoPais: {
      numeric,
      required,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    afipCuitPais: {
      numeric,
      required,
      minValue: minValue(0),
      maxValue: maxValue(99999999999)
    },
  },  
}
</script>

<style>
</style>
